export const TRACK_EVENT = "ANALYTICS/TRACK_EVENT";
export const TRACK_PURCHASE = "ANALYTICS/TRACK_PURCHASE";
